<p-dialog
  [header]="'Play Today' | translate"
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '420px' }"
  [breakpoints]="{ '640px': '94vw' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onClose()"
  styleClass="matchmaking-dialog"
>
  <!-- Earliest Slot Banner -->
  <div class="slot-banner" [class.no-slots]="!loadingSlot() && !earliestSlotTime()">
    @if (loadingSlot()) {
      <p-progressSpinner [style]="{ width: '16px', height: '16px' }" strokeWidth="4"></p-progressSpinner>
      <span class="slot-text">{{ 'Earliest available slot' | translate }}...</span>
    } @else if (earliestSlotTime()) {
      <i class="pi pi-clock slot-icon"></i>
      <span class="slot-text">{{ 'Earliest available slot' | translate }}: <strong>{{ earliestSlotTime() }}</strong></span>
    } @else {
      <i class="pi pi-ban slot-icon"></i>
      <span class="slot-text">{{ 'No available slots for today' | translate }}. {{ 'Please try again tomorrow' | translate }}.</span>
    }
  </div>

  <!-- Info Notes -->
  <div class="info-notes">
    <div class="note">
      <i class="pi pi-info-circle"></i>
      <span>{{ 'matchmaking_ai_note' | translate }}</span>
    </div>
    <div class="note">
      <i class="pi pi-times-circle"></i>
      <span>{{ 'matchmaking_cancel_note' | translate }}</span>
    </div>
  </div>

  <!-- Form Sections -->
  <div class="form-sections" [class.disabled-section]="noSlotsAvailable()">
    @if (showFacilityPicker()) {
      <div class="form-group">
        <label class="form-label">{{ 'Select facility' | translate }}</label>
        <app-facility-tabs
          [facilities]="matchmakingFacilities()"
          [selectedFacilityId]="selectedFacilityId"
          (selectedFacilityIdChange)="selectedFacilityId = $event"
        ></app-facility-tabs>
      </div>
    }

    <!-- Match Type -->
    <div class="form-group">
      <label class="form-label">{{ 'Select match type' | translate }}</label>
      <p-selectButton
        [options]="matchOptions"
        [(ngModel)]="selectedMatchType"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        [disabled]="noSlotsAvailable()"
        styleClass="match-type-select"
      ></p-selectButton>
    </div>

    <!-- Player Preference -->
    <div class="form-group">
      <label class="form-label">{{ 'Player preference' | translate }}</label>
      <p-selectButton
        [options]="favoritesOptions"
        [(ngModel)]="selectedFavoritesPreference"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        [disabled]="noSlotsAvailable() || notEnoughFavorites()"
        styleClass="favorites-select"
      ></p-selectButton>
      @if (notEnoughFavorites()) {
        <div class="favorites-warning">
          <i class="pi pi-info-circle"></i>
          <span>{{ 'You need at least 3 favorite players to use Favorites Only' | translate }}.
            <a (click)="goToPreferences()">{{ 'Add more favorites' | translate }}</a>
          </span>
        </div>
      }
    </div>
  </div>

  <!-- Preferences Hint -->
  <div class="preferences-hint">
    <i class="pi pi-star-fill"></i>
    <span>
      {{ 'For better results, adjust your' | translate }}
      <a (click)="goToPreferences()">{{ 'player preferences' | translate }}</a>
    </span>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <button
      pButton
      type="button"
      [label]="'Cancel' | translate"
      (click)="onClose()"
      class="btn-cancel"
      severity="secondary"
      [outlined]="true"
    ></button>
    <button
      pButton
      type="button"
      [label]="'Find Match' | translate"
      icon="pi pi-search"
      (click)="onConfirm()"
      [disabled]="noSlotsAvailable()"
      class="btn-confirm"
    ></button>
  </div>

  <!-- How it works link -->
  <div class="how-it-works-link">
    <a (click)="openHowItWorks()">
      <i class="pi pi-question-circle"></i>
      {{ 'How it works' | translate }}
    </a>
  </div>
</p-dialog>

<app-matchmaking-how-it-works
  [(visible)]="showHowItWorks"
></app-matchmaking-how-it-works>
